import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
// This Module's Components
import { FlyoutSearchComponent } from './flyout-search.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    DataLayerModule,
    ModalModule.forRoot()
  ],
  declarations: [FlyoutSearchComponent],
  exports: [FlyoutSearchComponent]
})
export class FlyoutSearchModule {}
